import { useEffect, useMemo, useState, useCallback } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Movies from './Movies';
import MovieLoading from './utils/Loading';
import TagList from './TagList';
import SearchBar from './SearchBar'; // new component for dummy search bar
import { fetchData } from '../api';

import './Sidebar.css';

const BATCH_SIZE = 15;
const DISPLAY_STEP = 5;

const Sidebar = ({ allMovies }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();

  // Get tags from URL
  const tagsParam = searchParams.get('tags') || '';
  const selectedTags = useMemo(() => tagsParam ? tagsParam.split(',').filter(t => t.trim()) : [], [tagsParam]);

  const handleTagClick = (tagName) => {
    navigate(`/search?tags=${tagName}`);
  };

  // Compute tag cloud from all fetched movies
  const tagCloud = {};
  const tagCount = {};

  allMovies.forEach(movie => {
    movie.tags.forEach(tag => {
      if (!tagCloud[tag.name]) {
          tagCount[tag.name] = 0;
      }
      tagCount[tag.name] += 1;
    })
  });

  const MAX_TAGS = 25;
  const topTags = new Set(
    Object.entries(
        tagCount
    ).sort(
        (a, b) => b[1] - a[1]
    ).slice(0, 10).map(([name]) => name)
 );

  allMovies.forEach(movie => {
    if (movie.tags && Array.isArray(movie.tags)) {
      movie.tags.forEach(tag => {
        if (!["metadata", "staff"].includes(tag.category) && topTags.has(tag.name)) {
            if (!tagCloud[tag.category]) {
                tagCloud[tag.category] = new Set();
            }
            tagCloud[tag.category].add(tag.name);
        }
      });
    }
  });

  const groupedTags = Object.entries(tagCloud).map(([category, names]) => ({
    category,
    names: Array.from(names)
  }));

  return (
    <aside className="recommendations-sidebar">
      <SearchBar selectedTags={selectedTags} setSearchParams={setSearchParams} />
      <TagList groupedTags={groupedTags} onTagClick={handleTagClick} />
    </aside>
  );
};

export default Sidebar;
